import Icon from 'vue-awesome/components/Icon'

Icon.register({
  fiber_smart_record_sharp: {
    raw: '<path fill="none" d="M0 0h24v24H0V0z"/><circle cx="9" cy="12" r="8"/><path d="M17 4.26v2.09a5.99 5.99 0 010 11.3v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z"/>',
    width: '24',
    height: '24'
  }
})
